/* av-cart-extras.js — Insurance + Savings Banner + Discount Badges + Cart Upsell */
(function () {
  'use strict';

  var INS_VID    = 56863148605820;
  var INS_HANDLE = 'shipping-protection';
  var LS_KEY     = 'av_sw_upsell';
  var OPTOUT_KEY = 'av_ins_optout';
  var TIERS      = [{ qty: 3, rate: 25 }, { qty: 2, rate: 15 }];
  var insBusy    = false;  /* an insurance add is in flight — stops the auto-add firing twice */
  var insPrice   = null;   /* protection price in cents, read from the cart or the product */

  /* ── helpers ── */
  /* Shopify answers a throttled or rejected cart call with 429/422 and a body that is
     often HTML, not JSON. Both helpers below reject on a non-2xx instead of resolving
     with whatever came back — a cart write that fails quietly is how the protection box
     ended up impossible to untick. */
  function fetchCart() {
    return fetch('/cart.js').then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }
  function cartPost(path, body) {
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (t) {
          throw new Error(path + ' ' + r.status + ' ' + t.slice(0, 120));
        });
      }
      return r.json();
    });
  }
  function cartPostRefresh(path, bodyObj) {
    bodyObj.sections = 'cart-drawer';
    return cartPost(path, bodyObj).then(function (data) {
      var html = data.sections && data.sections['cart-drawer'];
      if (html) { applyCartHtml(html); }
      else {
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        setTimeout(onDrawerOpen, 150);
      }
      return data;
    });
  }
  function applyCartHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var n = tmp.querySelector('[id="CartDrawer"]');
    var o = document.getElementById('CartDrawer');
    if (n && o) { o.innerHTML = n.innerHTML; }
    setTimeout(function () { fetchCart().then(renderAll).catch(function () {}); }, 60);
  }
  function realItems(cart) {
    return cart.items.filter(function (i) { return i.variant_id != INS_VID; });
  }
  function discountInfo(cart) {
    var items = realItems(cart);
    var qty   = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    var cur = null, nxt = null;
    for (var j = 0; j < TIERS.length; j++) {
      if (!cur && qty >= TIERS[j].qty) cur = TIERS[j];
      if (!nxt && qty <  TIERS[j].qty) nxt = TIERS[j];
    }
    /* Charge the tier against original_line_price, NOT line_price. line_price is the line
       total AFTER discount allocations, so rate% of it is rate% of an already-discounted
       number — 0.15 x 0.85 = 12.75% of the real total. That is why the banner read "–107"
       while the cart's own Savings row three lines below said "-125,70 kr". */
    var savingsCents = cur
      ? items.reduce(function (s, i) {
          var base = (i.original_line_price != null) ? i.original_line_price : i.line_price;
          return s + Math.round(base * cur.rate / 100);
        }, 0)
      : 0;
    return { qty: qty, rate: cur ? cur.rate : 0, nextRate: nxt ? nxt.rate : null,
             needForNext: nxt ? nxt.qty - qty : null, savingsCents: savingsCents };
  }

  /* ── insurance ──
     Protection is added for the shopper rather than waiting to be asked for. An explicit
     untick is remembered for as long as that cart lives: the flag clears the moment the
     cart holds no real items, so a fresh cart starts protected again, but a "no" is never
     overridden inside the cart it was given in. Without that memory the auto-add would
     re-tick the box on every drawer open and there would be no way to decline. */
  function hasInsurance(cart) {
    return cart.items.some(function (i) { return i.variant_id == INS_VID; });
  }
  function optedOut() {
    try { return localStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(on) {
    try {
      if (on) { localStorage.setItem(OPTOUT_KEY, '1'); }
      else    { localStorage.removeItem(OPTOUT_KEY); }
    } catch (e) {}
  }
  /* An empty cart is a new cart — forget what the last one decided. */
  function resetOptOutIfEmpty(cart) {
    if (!realItems(cart).length) setOptOut(false);
  }
  function wantsInsurance(cart) {
    if (insBusy || optedOut()) return false;
    if (!realItems(cart).length) return false;
    return !hasInsurance(cart);
  }
  /* This store exposes neither Shopify.money_format nor Shopify.formatMoney, and the theme
     renders prices as "289,00 kr". Formatting off the *browser* locale would print
     "DKK 35.00" to an en-US visitor sitting right next to "289,00 kr", so the locale is
     chosen from the active currency instead of from the visitor. */
  var MONEY_LOCALE = { DKK: 'da-DK', SEK: 'sv-SE', NOK: 'nb-NO', EUR: 'de-DE',
                       GBP: 'en-GB', USD: 'en-US', CAD: 'en-CA' };
  var MONEY_SUFFIX = { DKK: 'kr', SEK: 'kr', NOK: 'kr' };
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
    var n;
    try {
      n = (cents / 100).toLocaleString(MONEY_LOCALE[cur] || 'da-DK',
            { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { n = (cents / 100).toFixed(2); }
    return n + ' ' + (MONEY_SUFFIX[cur] || cur);
  }
  /* Price comes from the cart line when protection is in the cart, otherwise from the
     product. Never hardcode it — the label read "+37 kr" against a 35,00 kr variant. */
  function insLabel(cart) {
    var line = cart.items.filter(function (i) { return i.variant_id == INS_VID; })[0];
    if (line) insPrice = line.price;
    if (insPrice == null) return '';
    return '+' + money(insPrice);
  }
  function loadInsPrice() {
    if (insPrice != null) return;
    fetch('/products/' + INS_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vs = p.variants || [];
        var v = vs.filter(function (x) { return x.id == INS_VID; })[0] || vs[0];
        if (v) insPrice = v.price;
      }).catch(function () {});
  }
  /* Silent add at page load, covering the case where the drawer is never opened. Repaints
     the header count so the bubble can't disagree with the cart. */
  function ensureInsurance() {
    fetchCart().then(function (cart) {
      resetOptOutIfEmpty(cart);
      if (!wantsInsurance(cart)) return;
      insBusy = true;
      cartPost('/cart/add.js', { id: INS_VID, quantity: 1, sections: 'cart-icon-bubble' })
        .then(function (d)  { insBusy = false; refreshCartBubble(d && d.sections); })
        .catch(function () { insBusy = false; });
    }).catch(function () {});   /* throttled cart read — leave the cart alone this pass */
  }
  /* Remove by line-item key, never by bare variant id: change.js resolves a variant id
     ambiguously and can no-op without erroring. The key always names exactly one line. */
  function removeInsurance() {
    return fetchCart().then(function (cart) {
      var line = cart.items.filter(function (i) { return i.variant_id == INS_VID; })[0];
      if (!line) return null;
      return cartPostRefresh('/cart/change.js', { id: line.key, quantity: 0 });
    });
  }
  function refreshCartBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var host = document.getElementById('cart-icon-bubble');
    if (!html || !host) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    /* Only swap on an exact id match. Falling back to firstElementChild would paste the
       section wrapper's markup into the anchor and mangle the header. If it isn't there,
       leave the count alone — the next page load renders it correctly anyway. */
    var next = tmp.querySelector('[id="cart-icon-bubble"]');
    if (next) host.innerHTML = next.innerHTML;
  }
  function renderInsuranceToggle(cart) {
    var el = document.getElementById('av-ins-toggle');
    if (el) el.remove();
    var footer = document.querySelector('.drawer__footer');
    if (!footer) return;
    var ri  = realItems(cart);
    if (!ri.length) return;
    var has = hasInsurance(cart);
    var div = document.createElement('div');
    div.id  = 'av-ins-toggle';
    div.innerHTML =
      '<label class="av-ins-row">' +
        '<input type="checkbox" class="av-ins-check"' + (has ? ' checked' : '') + '>' +
        '<span class="av-ins-icon"><svg width="13" height="13" viewBox="0 0 24 24" fill="none"' +
        ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></span>' +
        '<span class="av-ins-text">Shipping Protection</span>' +
        '<span class="av-ins-price">' + insLabel(cart) + '</span>' +
      '</label>';
    footer.insertBefore(div, footer.firstChild);
    var check = div.querySelector('.av-ins-check');
    check.addEventListener('change', function (e) {
      var checked = e.target.checked;
      setOptOut(!checked);        /* record the answer before the round-trip */
      check.disabled = true;
      var p = checked
        ? cartPostRefresh('/cart/add.js', { id: INS_VID, quantity: 1 })
        : removeInsurance();
      p.catch(function () {
        setOptOut(checked);       /* the write failed — put the flag back as it was */
        check.checked = !checked; check.disabled = false;
      });
    });
  }

  /* ── savings banner — lives in footer, below insurance toggle ── */
  function renderSavingsBanner(cart) {
    var el = document.getElementById('av-savings-banner');
    if (el) el.remove();
    var info   = discountInfo(cart);
    var footer = document.querySelector('.drawer__footer');
    if (!footer) return;
    var html;
    if (info.rate >= 25) {
      html = '<div id="av-savings-banner" class="av-sb av-sb--on">' +
        '<span class="av-sb-pill">' + info.rate + '% off</span>' +
        '<span class="av-sb-msg">Bundle discount applied</span>' +
        '<span class="av-sb-amt">–' + money(info.savingsCents) + '</span>' +
      '</div>';
    } else if (info.rate >= 15) {
      html = '<div id="av-savings-banner" class="av-sb av-sb--on">' +
        '<span class="av-sb-pill">' + info.rate + '% off</span>' +
        '<span class="av-sb-msg">Add <strong>' + info.needForNext + '</strong> more for <strong>25% off</strong></span>' +
        '<span class="av-sb-amt">–' + money(info.savingsCents) + '</span>' +
      '</div>';
    } else if (info.qty === 1) {
      html = '<div id="av-savings-banner" class="av-sb av-sb--nudge">' +
        '<span class="av-sb-msg">Add <strong>1 more</strong> to save 15% &nbsp;·&nbsp; 3+ saves 25%</span>' +
      '</div>';
    } else { return; }
    var div = document.createElement('div');
    div.innerHTML = html;
    var banner = div.firstChild;
    var toggle = document.getElementById('av-ins-toggle');
    if (toggle) { toggle.insertAdjacentElement('afterend', banner); }
    else         { footer.insertBefore(banner, footer.firstChild); }
  }

  /* ── per-item discount badges ── */
  function renderDiscountBadges(cart) {
    document.querySelectorAll('.av-discount-badge').forEach(function (b) { b.remove(); });
    var info = discountInfo(cart);
    if (!info.rate) return;
    document.querySelectorAll('.cart-item').forEach(function (item) {
      if (item.classList.contains('cart-item--product-shipping-protection')) return;
      if (item.querySelector('.av-discount-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'av-discount-badge';
      badge.textContent = '−' + info.rate + '%';
      var title   = item.querySelector('.cart-item__title');
      var details = item.querySelector('.cart-item__details');
      if (title && title.parentNode === details) { title.insertAdjacentElement('afterend', badge); }
      else if (details) { details.insertBefore(badge, details.firstChild); }
    });
  }

  /* ── cart upsell ── */
  function getStoredUpsell() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)); } catch (e) { return null; }
  }
  function renderCartUpsell(cart) {
    var el = document.getElementById('av-cart-upsell');
    if (el) el.remove();
    var data = getStoredUpsell();
    if (!data || !data.items || !data.items.length) return;
    var cartHandleSet = {};
    cart.items.forEach(function (i) { if (i.handle) cartHandleSet[i.handle.toLowerCase()] = true; });
    var toShow = data.items.filter(function (item) {
      var h = (item.handle || '').toLowerCase().trim();
      if (!h || h === INS_HANDLE) return false;
      if (cartHandleSet[h]) return false;
      if (item.url) { var m = item.url.match(/\/products\/([^?/#]+)/); if (m && cartHandleSet[m[1].toLowerCase()]) return false; }
      return true;
    }).slice(0, 4);
    if (!toShow.length) return;
    var body = document.querySelector('.cart-drawer__body');
    if (!body) return;
    var info = discountInfo(cart);
    var saveLabel = info.rate >= 25 ? 'Saving 25%' : info.rate >= 15 ? 'Add 1 → Save 25%' : 'Save 15%';
    var html = '<div id="av-cart-upsell">' +
      '<p class="av-cu-title">Complete your look <span class="av-cu-save">' + saveLabel + '</span></p>' +
      '<div class="av-cu-track">';
    toShow.forEach(function (item) {
      html += '<div class="av-cu-card">' +
        '<a class="av-cu-link" href="' + item.url + '">' +
          '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '') + '" loading="lazy" width="80" height="100">' +
        '</a>' +
        '<span class="av-cu-name">' + (item.title || '') + '</span>' +
        '<span class="av-cu-price">' + (item.price || '') + '</span>' +
        '<button class="av-cu-atb" data-handle="' + (item.handle || '') + '">Add to bag</button>' +
      '</div>';
    });
    html += '</div></div>';
    var div = document.createElement('div');
    div.innerHTML = html;
    body.appendChild(div.firstChild);

    /* add-to-bag handler — delegate on upsell container */
    var upsell = document.getElementById('av-cart-upsell');
    if (upsell) {
      upsell.addEventListener('click', function (e) {
        var btn = e.target.closest('.av-cu-atb');
        if (!btn || btn.disabled) return;
        var handle = btn.dataset.handle;
        if (!handle) return;
        btn.textContent = '…';
        btn.disabled    = true;
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var v = p.first_available_variant || (p.variants && p.variants[0]);
            if (!v) { btn.textContent = 'Unavailable'; return; }
            return cartPostRefresh('/cart/add.js', { id: v.id, quantity: 1 });
          })
          .catch(function () { btn.textContent = 'Add to bag'; btn.disabled = false; });
      });
    }
  }

  /* ── render all ── */
  function renderAll(cart) {
    renderInsuranceToggle(cart);   // footer anchor must exist before banner
    renderSavingsBanner(cart);
    renderCartUpsell(cart);
    renderDiscountBadges(cart);
  }

  /* Opening the drawer is the reliable moment to top the cart up: at page load the cart is
     usually still empty, because the shopper adds the first item after the page has settled. */
  function onDrawerOpen() {
    fetchCart().then(function (cart) {
      resetOptOutIfEmpty(cart);
      if (!wantsInsurance(cart)) { renderAll(cart); return; }
      insBusy = true;
      cartPostRefresh('/cart/add.js', { id: INS_VID, quantity: 1 })
        .then(function ()  { insBusy = false; })            /* refresh re-renders for us */
        .catch(function () {
          insBusy = false;
          fetchCart().then(renderAll).catch(function () {});   /* still draw what we can */
        });
    }).catch(function () {});
  }

  /* ── watch drawer open/close ── */
  function watchDrawer() {
    var el = document.querySelector('cart-drawer');
    if (!el) return;
    var wasActive = false;
    new MutationObserver(function () {
      var on = el.classList.contains('active');
      if (on && !wasActive) { wasActive = true; onDrawerOpen(); }
      if (!on) wasActive = false;
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── watch for Shopify-native cart re-renders (qty +/-) ── */
  function watchCartBody() {
    var timer;
    new MutationObserver(function () {
      var drawerEl = document.querySelector('cart-drawer');
      if (!drawerEl || !drawerEl.classList.contains('active')) return;
      if (document.getElementById('av-ins-toggle')) return; /* our render already ran */
      clearTimeout(timer);
      timer = setTimeout(onDrawerOpen, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    loadInsPrice();
    ensureInsurance();
    watchDrawer();
    watchCartBody();
    /* also catch any cart:change events the theme may dispatch */
    document.addEventListener('cart:change', function () {
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && drawerEl.classList.contains('active')) {
        setTimeout(onDrawerOpen, 80);
      }
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
